// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-cell {
  color: dimgray !important;
}

.main-col {
  color: black !important;
  font-weight: bolder;
}

.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {
  color: rgba(0, 0, 0, 0.54);
}

.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__trailing,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__notch,
.mat-mdc-paginator::ng-deep .mdc-text-field::ng-deep .mdc-notched-outline__leading {
  border: none !important;
}

.editable-grid {
  margin-top: 10px;
  margin-bottom: 25px;
  margin-right: 10px;
  margin-left: 10px;
}
.editable-grid table {
  width: 100%;
  background-color: transparent;
}
.editable-grid table tr.mat-mdc-header-row {
  background-color: transparent !important;
}
.editable-grid table tr.mat-mdc-row {
  background: transparent !important;
}
.editable-grid table tr.mat-mdc-row:nth-child(2n+1):not(.expand-row) {
  background-color: rgba(0, 0, 0, 0.0196078431) !important;
}
.editable-grid table th {
  padding-bottom: 10px;
}
.editable-grid table th,
.editable-grid table td {
  padding-right: 20px;
  padding-left: 10px;
  position: relative;
}
.editable-grid table th:last-child,
.editable-grid table td:last-child {
  padding-right: 0px;
}
.editable-grid table .mat-mdc-form-field {
  width: 100%;
}
.editable-grid table span.tooltip {
  display: inline-block;
  width: 100%;
}
.editable-grid .actions-col {
  text-align: right;
  width: 40px;
  padding-right: 0px !important;
}
.editable-grid .actions-col .clear-icon {
  cursor: pointer;
}
.editable-grid .actions-col .clear-icon mat-icon {
  color: #ed6b75;
  font-size: 15px;
  line-height: 25px;
}
.editable-grid .add-item button {
  padding-right: 8px;
}
.editable-grid .add-item mat-icon {
  margin-left: 10px;
}
.editable-grid .value,
.editable-grid .input-container {
  margin-top: 10px;
  margin-bottom: 10px;
  min-height: 20px;
}
.editable-grid .input-td {
  vertical-align: top;
}
.editable-grid ::ng-deep .mat-mdc-form-field-infix {
  width: 100% !important;
}
.editable-grid ::ng-deep .mat-mdc-form-field .mat-mdc-input-element:disabled {
  cursor: pointer;
}
.editable-grid ::ng-deep .mat-mdc-form-field .mat-input-element:disabled,
.editable-grid ::ng-deep .mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix::after {
  color: rgba(0, 0, 0, 0.87);
}
.editable-grid ::ng-deep .mat-mdc-form-field.mat-form-field-disabled .mat-form-field-underline {
  background-image: unset !important;
  background-color: rgba(0, 0, 0, 0.42) !important;
}
.editable-grid ::ng-deep .mat-mdc-form-field .mat-form-field-infix {
  width: 100% !important;
}
.editable-grid ::ng-deep .mat-mdc-form-field.has-error {
  color: orange;
}
.editable-grid ::ng-deep .mat-mdc-form-field.has-error .mat-input-element:disabled,
.editable-grid ::ng-deep .mat-mdc-form-field.has-error .mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix::after,
.editable-grid ::ng-deep .mat-mdc-form-field.has-error .mat-form-field-label {
  color: orange !important;
}
.editable-grid ::ng-deep .mat-mdc-form-field.has-error .mat-form-field-underline {
  background-color: orange !important;
}
.editable-grid .error-messages {
  color: #ed6b75;
  font-size: 10.5px;
}
.editable-grid .error-icon {
  font-size: 16px;
}
.editable-grid .info {
  color: #ed6b75;
  font-size: 10.5px;
}
.editable-grid .hand {
  cursor: pointer;
}
.editable-grid .hidden {
  display: none;
}
.editable-grid .err-sign {
  color: #ed6b75;
  position: absolute;
  left: 0;
  top: 14px;
}
.editable-grid .field-errors {
  height: 40px;
}
.editable-grid .no-value {
  color: orange;
  font-size: 10.5px;
  min-height: 20px;
  width: 100%;
}
.editable-grid .value {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.editable-grid .addLabelButtonClass {
  position: relative;
  color: #919191;
  right: 12px;
}
.editable-grid .tooltip-icon {
  display: inline-block;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.scss","webpack://./src/app/components/forms/editablegridfield/editable-grid-field.component.scss"],"names":[],"mappings":"AA0EA;EACE,yBAAA;ACzEF;;AD2EA;EACE,uBAAA;EACA,mBAAA;ACxEF;;AD2EA;EACE,0BAAA;ACxEF;;AD6EM;;;EAII,uBAAA;AC3EV;;AAdA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAiBJ;AAfI;EACI,WAAA;EACA,6BAAA;AAiBR;AAfQ;EACI,wCAAA;AAiBZ;AAdQ;EACI,kCAAA;AAgBZ;AAbQ;EACI,wDAAA;AAeZ;AAZQ;EACI,oBAAA;AAcZ;AAZQ;;EAGI,mBAAA;EACA,kBAAA;EACA,kBAAA;AAaZ;AAVQ;;EAEI,kBAAA;AAYZ;AATQ;EACI,WAAA;AAWZ;AARQ;EACI,qBAAA;EACA,WAAA;AAUZ;AANI;EACI,iBAAA;EACA,WAAA;EACA,6BAAA;AAQR;AAPQ;EACI,eAAA;AASZ;AARY;EACI,cDqEL;ECpEK,eAAA;EACA,iBAAA;AAUhB;AAJQ;EACI,kBAAA;AAMZ;AAJQ;EACI,iBAAA;AAMZ;AAFI;;EAEI,gBAAA;EACA,mBAAA;EACA,gBAAA;AAIR;AAFI;EACI,mBAAA;AAIR;AAAQ;EACI,sBAAA;AAEZ;AAAQ;EACI,eAAA;AAEZ;AAAQ;;EAEI,0BAAA;AAEZ;AAAQ;EACI,kCAAA;EACA,gDAAA;AAEZ;AAAQ;EACI,sBAAA;AAEZ;AACQ;EACI,aAAA;AACZ;AAAY;;;EAGI,wBAAA;AAEhB;AAAY;EACI,mCAAA;AAEhB;AAGI;EACI,cDUG;ECTH,iBAAA;AADR;AAOI;EACI,eAAA;AALR;AAQI;EACI,cDFG;ECGH,iBAAA;AANR;AASI;EACI,eAAA;AAPR;AAUI;EACI,aAAA;AARR;AAWI;EACI,cDfG;ECgBH,kBAAA;EACA,OAAA;EACA,SAAA;AATR;AAWI;EACI,YAAA;AATR;AAYI;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAVR;AAYI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAVR;AAaI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;AAXR;AAcI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AAZR","sourcesContent":["@use '@angular/material' as mat;\n// theme.scss\n\n$my-app: (\n  10:  #e8fafb2e,\n  50:  #32c5d22e,\n  100: #32c5d23d,\n  200: orange,\n  300: #32c5d25c,\n  400: #8cdce4,\n  500: #32c5d2c2,\n  600: #32c5d2,\n  700: #1f858e,\n  800: #18666d,\n  900: #337ab7,\n  A100: #ffffff,\n  A200: #def6f8,\n  A400: #a1f3fb,\n  A700: #7aecf7,\n  contrast: (\n    50 : #32c5d25c,\n    100 : #32c5d2c2,\n    200 : white,\n    300 : #1f858e,\n    400 : #18666d,\n    500 : #337ab7,\n    600 : #ffffff,\n    700 : #ffffff,\n    800 : #ffffff,\n    900 : #ffffff,\n    A100 : #32c5d2,\n    A200 : #1f858e,\n    A400 : #18666d,\n    A700 : #337ab7,\n  ));\n\n$my-app-primary: mat.m2-define-palette($my-app, 600);\n$my-app-accent : mat.m2-define-palette($my-app, 900);\n$my-app-warn : mat.m2-define-palette($my-app, 200);\n$my-app-sidebar : mat.m2-define-palette($my-app, 10);\n$my-app-background : mat.m2-define-palette($my-app, 50);\n$my-app-colored-card : mat.m2-define-palette($my-app, 100);\n$my-app-light : mat.m2-define-palette($my-app, 200);\n\n\n$comv-typography-config: mat.m2-define-typography-config(\n\n  $body-1: mat.m2-define-typography-level(14px, 21px, 400) \n  // ...\n);\n\n$my-theme: mat.m2-define-light-theme((\n  color: (\n    primary: $my-app-primary,\n    accent: $my-app-accent,\n    warn: $my-app-warn\n  ),\n  typography: $comv-typography-config,\n  density: 0,\n));\n\n$comv-dark-blue: #26344B;\n$comv-middle-blue: #337ab7;\n$comv-primary-blue: #32c5d2;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab1: #0175c0;\n$comv-tab2: #009BC6;\n$comv-ultralight-gray: rgba(242, 242, 242, 0.15); \n$comv-table-header-border: #a8b7c1;\n\n\n.mat-mdc-cell {\n  color:dimgray !important;\n}\n.main-col {\n  color: black !important;\n  font-weight: bolder;\n}\n\n.mat-mdc-paginator, .mat-mdc-paginator-page-size .mat-mdc-select-trigger {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mat-mdc-paginator::ng-deep {\n  .mdc-text-field::ng-deep {\n      .mdc-notched-outline__trailing,\n      .mdc-notched-outline__notch,\n      .mdc-notched-outline__leading\n       {\n          border: none !important;\n      }\n  }\n}\n\n$comv-blue-dark :#04488f;\n$comv-blue-medium :#0175c0;\n$comv-blue-light :#00b0e1;\n$comv-gray-medium :#8f8f8f;\n$comv-yellow-light :#ecb842;\n$comv-yellow-dark :#e6a540;\n$comv-pink-light :#aa488d;\n$comv-pink-dark :#7d478e;\n$comv-green-light :#8db854;\n$comv-green-dark :#54763f;\n\n\n//$comv-dark-blue: #26344B;\n// $comv-dark-blue : $comv-blue-dark;\n\n//$comv-middle-blue: #337ab7;\n$comv-middle-blue: $comv-blue-medium;\n//$comv-primary-blue: #28b5b9;  \n$comv-primary-blue: $comv-blue-light;\n\n$comv-primary-blue-hover: #32c5d2;  \n\n//$comv-accent-blue: #0065AF;\n$comv-accent-blue: $comv-blue-medium;\n$comv-accent-blue-hover: #0075C9;\n$comv-light-blue1: #EDF9FD;\n$comv-light-blue2: #D7F3FB;\n$comv-light-blue3: #009BC6; \n$comv-light-blue3-hover: #00b3e3;\n\n$comv-red: #ed6b75;\n$comv-light-gray: #f1f1f1;\n$comv-tab-icon:$comv-middle-blue;\n$comv-tab-icon-hover:$comv-primary-blue;\n\n$comv-grid-highlight: #f6f6f6;\n$comv-grid-hover: #D7F3FB;\n\n$comv-chips-color: $comv-light-gray;\n\n$comv-admo-matched: greenyellow;\n$comv-admo-disabled: lightgray;\n$comv-admo-validated: green;\n$comv-admo-published: $comv-primary-blue;\n$comv-admo-split: #7e478e87;\n$comv-admo-merge: #ffa500;","@use \"@angular/material\" as mat;\n@import \"../../../../theme/theme.scss\";\n\n.editable-grid {\n    margin-top: 10px;\n    margin-bottom: 25px;\n    margin-right: 10px;\n    margin-left: 10px;\n\n    table {\n        width: 100%;\n        background-color: transparent;\n\n        tr.mat-mdc-header-row {\n            background-color: transparent!important;\n        }\n\n        tr.mat-mdc-row {\n            background: transparent!important;\n        }\n\n        tr.mat-mdc-row:nth-child(2n+1):not(.expand-row) {\n            background-color: #00000005!important;\n        }\n\n        th {\n            padding-bottom: 10px;\n        }\n        th,\n        td {\n            // border-color: transparent;\n            padding-right: 20px;\n            padding-left: 10px;\n            position: relative;\n        }\n\n        th:last-child,\n        td:last-child {\n            padding-right: 0px;\n        }\n\n        .mat-mdc-form-field {\n            width: 100%;\n        }\n\n        span.tooltip {\n            display: inline-block;\n            width: 100%;\n        }\n    }\n\n    .actions-col {\n        text-align: right;\n        width: 40px;\n        padding-right: 0px !important;\n        .clear-icon {\n            cursor: pointer;\n            mat-icon {\n                color: $comv-red;\n                font-size: 15px;\n                line-height: 25px;\n            }\n        }\n    }\n\n    .add-item {\n        button {\n            padding-right: 8px;\n        }\n        mat-icon {\n            margin-left: 10px;\n        }\n    }\n\n    .value,\n    .input-container {\n        margin-top: 10px;\n        margin-bottom: 10px;\n        min-height: 20px;\n    }\n    .input-td {\n        vertical-align: top;\n    }\n\n    ::ng-deep {\n        .mat-mdc-form-field-infix {\n            width: 100%!important;\n        }\n        .mat-mdc-form-field .mat-mdc-input-element:disabled {\n            cursor: pointer;\n        }\n        .mat-mdc-form-field .mat-input-element:disabled,\n        .mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix::after {\n            color: rgba(0, 0, 0, 0.87);\n        }\n        .mat-mdc-form-field.mat-form-field-disabled .mat-form-field-underline {\n            background-image: unset !important;\n            background-color: rgba(0, 0, 0, 0.42) !important;\n        }\n        .mat-mdc-form-field .mat-form-field-infix {\n            width: 100% !important;\n        }\n\n        .mat-mdc-form-field.has-error {\n            color: mat.m2-get-color-from-palette($my-app-warn);\n            .mat-input-element:disabled,\n            .mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix::after,\n            .mat-form-field-label {\n                color: mat.m2-get-color-from-palette($my-app-warn) !important;\n            }\n            .mat-form-field-underline {\n                background-color: mat.m2-get-color-from-palette($my-app-warn) !important;\n            }\n        }\n    }\n\n    .error-messages {\n        color: $comv-red;\n        font-size: 10.5px;\n        // margin-top: -12px;\n        // position: absolute;\n        // bottom: -1px;\n        // height: 16px;\n    }\n    .error-icon {\n        font-size: 16px;\n    }\n\n    .info {\n        color: $comv-red;\n        font-size: 10.5px;\n    }\n\n    .hand {\n        cursor: pointer;\n    }\n\n    .hidden {\n        display: none;\n    }\n\n    .err-sign {\n        color: $comv-red;\n        position: absolute;\n        left: 0;\n        top: 14px;\n    }\n    .field-errors {\n        height: 40px;\n    }\n\n    .no-value {\n        color: mat.m2-get-color-from-palette($my-app-warn);\n        font-size: 10.5px;\n        min-height: 20px;\n        width: 100%;\n    }\n    .value {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .addLabelButtonClass {\n        position: relative;\n        color: #919191;\n        right: 12px;\n    }\n\n    .tooltip-icon {\n        display: inline-block;\n        width: 100%;\n        height: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
